/** Clé GoPaaS stable pour une ligne favori (upsert idempotent). `targetCle` = cle connexion club/match. */
export function favoriteClubCle(tifosiCle: string, clubCle: string): string {
  return `fav-club-${String(tifosiCle || '').trim()}-${String(clubCle || '').trim()}`;
}

export function favoriteMatchCle(tifosiCle: string, matchCle: string): string {
  return `fav-match-${String(tifosiCle || '').trim()}-${String(matchCle || '').trim()}`;
}